import { GetStaticPaths, GetStaticProps } from 'next';
import { getLocalePaths } from '@i18n';
import PrivacyMarkdown from '@components/pages/privacy';

// HOCs
import WithRoles, { rolesEnum } from '@HOCs/WithRole';

const Privacy: React.FC = () => {
    return <PrivacyMarkdown />;
};

export default WithRoles(Privacy, [rolesEnum.guest]);

export const getStaticProps: GetStaticProps = async ({ params }) => {
    return { props: { locale: params?.locale } };
};

export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: getLocalePaths(), fallback: false };
};
